export function setAbortableTimeout(fn: () => void, ms: number, signal: AbortSignal) {
  const t = setTimeout(() => {
    signal;
    fn();
    signal.removeEventListener('abort', abort);
  }, ms);

  const abort = () => clearTimeout(t);

  if (!signal.aborted) {
    signal.addEventListener('abort', abort, { once: true });
  }

  return t;
}
